import React from "react";

export default function Navbaradmin(){

  return(
    <header className="bg-white border-b p-4">
    <div className="flex justify-between items-center">
      <div>
        <span className="text-xl font-semibold">Welcome, Admin!</span>
      </div>
      <div>
        {/* Add any additional top navigation items or user profile info */}
      </div>
    </div>
  </header>
  )
}